// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__213Y2","resendInfoText":"OnGoingPaymentBox_resendInfoText__3UzdR"};